import React, {useState, useEffect, useLayoutEffect, useRef, useContext, useMemo} from 'react'
import {
  Grid,
  Typography,
  TextField,
  List,
  ListItem,
  ListItemText,
  Select,
  MenuItem,
  Button,
  Icon,
} from '@material-ui/core'
import moment from 'moment'
import CreateIcon from '@material-ui/icons/Create'
import CloseIcon from '@material-ui/icons/Close'
import './StepConfirmReservation.styles.scss'
import NotificationInput from '../CustomComponents/NotificationInput'
import {ReservationContext} from '../../../context/Reservation'
import LoadingIndicator from '../../ReservationConfiguration/LoadingIcon'
import ExpandIcon from './../../../assets/images/expand.svg'
import GlobalEvents from '../../../utils/EventSystem'
import ShrinkIcon from './../../../assets/images/shrink.png'
import './EditExpandIcon.styles.scss'
import _ from 'lodash'
import {useModal} from '../../../common/Modal'
import useReservationsReducer from './../../../state/reservation/create-reservation/reducer'
import {
  createReservation,
  resetReservation,
} from './../../../state/reservation/create-reservation/actions'

export default function StepConfirmReservation({
  handleEdit,
  onClose,
  handleReserve,
  date_format,
  time_format,
}) {
  const notifRef = useRef(null)
  const {
    reservation,
    reservations,
    formatSelectedItems,
    configuration,
    addReservation,
    editReservedReservation,
    update,
  } = useContext(ReservationContext)
  const simpleModal = useModal('simple', {})
  const [newReservations, reservationsDispatch] = useReservationsReducer()
  const [isMainApp, setIsMainApp] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [expandItems, setExpandItems] = useState(false)
  const [expandAdditional, setExpandAdditional] = useState(false)
  const addNotification = () => {
    update('reservation_notification', [
      ...reservation.reservation_notification,
      {time: 30, unit: 'minutes'},
    ])
    //notifRef.current.scrollIntoView({behavior: "smooth"});
  }

  const handleClickCancel = () => {
    if (simpleModal) {
      simpleModal.show({
        scheme: 'warning',
        title: 'Cancel Resevation',
        description: 'You will loose the progress. Are you sure?',
        buttons: {
          affirmative: {
            label: 'Yes',
            click: (data, modal) => {
              onClose()
              modal.hide()
            },
          },
          negative: {
            label: 'No',
          },
        },
      })
    }
  }

  const scrollToBottom = () => {
    notifRef.current.scrollIntoView({behavior: 'smooth'})
  }

  useEffect(scrollToBottom, [reservations])

  const removeNotification = index => {
    let tNotifs = reservation.reservation_notification
    tNotifs.splice(index, 1)

    update('reservation_notification', [...tNotifs])
  }
  const handleChangeHoldTime = (e, v, index) => {
    let tNotifs = reservation.reservation_notification
    tNotifs[index] = v

    update('reservation_notification', [...tNotifs])
  }
  const updateActionIds = group => {
    let field_id = []
    let action_ids = []
    !_.isEmpty(reservation.reserve_for_field) &&
      reservation.reserve_for_field.field_details.forEach(field => {
        if (field.entity_id === group?.id) {
          field_id.push(field.field_id)
        }
      })
    if (configuration.data?.action_steps) {
      configuration.data.action_steps.forEach(step => {
        let stepId = step.return_field_data.id
        if (field_id.includes(stepId)) {
          action_ids.push(step.action_id)
        }
      })
    }
    return {action_ids, field_id}
  }

  const deletedItems = useMemo(() => {
    let item = []
    reservation.original_items.forEach(o => {
      let exist = false
      reservation.selected_items.forEach(a => {
        if (a.id === o.id) {
          exist = true
        }
      })
      if (!exist) {
        item.push(o.id)
      }
    })
    return item
  }, [reservation])
  const handleReserveCreate = e => {
    setConfirmLoading(true)
    let reservationData = {
      entity_action_id: configuration?.data?.reservation_action?.id,
      entity_id: configuration?.data?.entity_id,
      object_ids: reservation?.selected_items?.map(sf => {
        return sf?.id
      }),
      action_fields: {
        start_date: moment
          .utc(reservation.date_from)
          .local()
          .format(),
        end_date: moment
          .utc(reservation.date_to)
          .local()
          .format(),
        comments: reservation.comments,
        additional_fields: reservation?.additional_fields?.length
          ? reservation.additional_fields.map(af => {
              return {
                key: af.key,
                value: af.value,
                type: af.type,
              }
            })
          : [],
      },
      reservation_confirmation: true,
      reservation_notification: reservation.reservation_notification,
      comments: reservation.comments,
      reserve_for: {
        field_id: updateActionIds(reservation.selected_group).field_id,
        value_id: reservation.reserved_for.id,
        value: reservation.reserved_for.name,
        action_ids: updateActionIds(reservation.selected_group).action_ids,
      },
    }
    if (reservation.is_edit) {
      editReservedReservation({
        ...reservationData,
        reservation_uid: reservation.reservation_uid,
        deleted_item_ids: deletedItems,
        states: reservation.states,
        status: reservation.status,
      })
    } else {
      addReservation(reservationData)
    }
  }

  const errorMsg = errorList => {
    return (
      <Grid item xs={12} style={{marginBottom: '10px'}}>
        {errorList.errors.map((e, i) => {
          return (
            <div key={i} className="c-reservation-error">
              {e}
            </div>
          )
        })}
      </Grid>
    )
  }

  useEffect(() => {
    var regex = /pop_reserve/
    setIsMainApp(regex.test(window.location.href))
  }, [])

  useEffect(() => {
    if (reservations.data.reservation_uid) {
      setConfirmLoading(false)
      handleReserve(reservations.data.reservation_uid)
      GlobalEvents.emit('reservation:new')
      if (!reservation.is_edit) {
        const current_location = localStorage.getItem('parent_origin')
        window.parent.postMessage(
          {key: 'CLOSE_POPUP', value: 'CLOSE_POPUP', id: reservations.data.reservation_uid},
          `${current_location}/asset_items`
        )
      }
    } else if (reservations.errors && reservations.errors.length) {
      setConfirmLoading(false)
    }
    // eslint-disable-next-line
  }, [handleReserve, reservations])

  return (
    <>
      <section>
        <Grid container className="ap-scrollbar">
          {reservations.errors && reservations.errors.length
            ? errorMsg(reservations)
            : newReservations.errors && newReservations.errors.length && errorMsg(newReservations)}
          <Grid item xs={6} style={{marginBottom: '16px'}}>
            <Typography div className="ap-typography ap-typography--xs ap-typography--gray">
              From
            </Typography>
            <Typography className="ap-typography ap-typography--sm c-editable-text">
              {moment(reservation.date_from).format(`${date_format} ${time_format}`)}
              <CreateIcon
                className="c-editable-text__edit-icon"
                onClick={() => {
                  handleEdit(1)
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className="ap-typography ap-typography--xs ap-typography--gray">
              To
            </Typography>
            <Typography className="ap-typography ap-typography--sm">
              {moment(reservation.date_to).format(`${date_format} ${time_format}`)}
              <CreateIcon
                className="c-editable-text__edit-icon"
                onClick={() => {
                  handleEdit(1)
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} style={{marginBottom: '25px'}}>
            <Typography className="ap-typography ap-typography--xs ap-typography--gray">
              For
            </Typography>
            <Typography className="ap-typography ap-typography--sm">
              {reservation.reserved_for.name}
              {reservation.is_edit === true ? (
                ' '
              ) : (
                <CreateIcon
                  className="c-editable-text__edit-icon"
                  onClick={() => {
                    handleEdit(2)
                  }}
                />
              )}
            </Typography>
          </Grid>
          <Grid item xs={12} style={{marginBottom: '16px'}}>
            <Typography className="ap-typography ap-typography--xs ap-typography--gray">
              Items{' '}
              <CreateIcon
                className="c-editable-text__item-edit-icon c-editable-text__edit-icon edit-icon"
                onClick={() => {
                  handleEdit(2)
                }}
              />
              {formatSelectedItems?.length > 5 && !expandItems && (
                <Icon
                  className="c-editable-text__item-edit-icon c-editable-text__edit-icon"
                  onClick={() => {
                    setExpandItems(!expandItems)
                  }}
                >
                  <img src={ExpandIcon} alt="expand" height={12} width={12} />
                </Icon>
              )}
              {formatSelectedItems?.length > 5 && expandItems && (
                <Icon
                  className="c-editable-text__item-edit-icon c-editable-text__edit-icon"
                  onClick={() => {
                    setExpandItems(!expandItems)
                  }}
                >
                  <img src={ShrinkIcon} alt="shrink" height={12} width={12} />
                </Icon>
              )}
            </Typography>
            {!expandItems ? (
              <List className="c-reserved-item-list">
                {formatSelectedItems?.slice(0, 5).map((item, i) => {
                  return (
                    <ListItem key={i} style={{padding: '0px 0px 4px 0px'}}>
                      <Typography className="ap-typography ap-typography--sm">
                        {item.label}
                      </Typography>
                    </ListItem>
                  )
                })}
              </List>
            ) : (
              <List className="c-reserved-item-list">
                {formatSelectedItems?.map((item, i) => {
                  return (
                    <ListItem key={i} style={{padding: '0px 0px 4px 0px'}}>
                      <Typography className="ap-typography ap-typography--sm">
                        {item.label}
                      </Typography>
                    </ListItem>
                  )
                })}
              </List>
            )}
          </Grid>

          {configuration.data.additional_fields && configuration.data.additional_fields.length ? (
            <Grid item xs={12} style={{marginBottom: '16px'}}>
              <Typography className="ap-typography ap-typography--xs ap-typography--gray">
                Additional Fields{' '}
                <CreateIcon
                  className="c-editable-text__item-edit-icon c-editable-text__edit-icon"
                  onClick={() => {
                    handleEdit(3)
                  }}
                />
                {reservation.additional_fields &&
                  reservation.additional_fields.length > 5 &&
                  !expandAdditional && (
                    <Icon
                      className="c-editable-text__item-edit-icon c-editable-text__edit-icon"
                      onClick={() => {
                        setExpandAdditional(!expandAdditional)
                      }}
                    >
                      <img src={ExpandIcon} alt="expand" height={12} width={12} />
                    </Icon>
                  )}
                {reservation.additional_fields &&
                  reservation.additional_fields.length > 5 &&
                  expandAdditional && (
                    <Icon
                      className="c-editable-text__item-edit-icon c-editable-text__edit-icon"
                      onClick={() => {
                        setExpandAdditional(!expandAdditional)
                      }}
                    >
                      <img src={ShrinkIcon} alt="shrink" height={12} width={12} />
                    </Icon>
                  )}
              </Typography>
              {!expandAdditional ? (
                <List className="c-reserved-item-list">
                  {reservation.additional_fields &&
                    reservation.additional_fields.slice(0, 5).map((item, i) => {
                      return (
                        <ListItem key={i} style={{padding: '0px 0px 4px 0px'}}>
                          <Grid container>
                            <Grid item xs={6}>
                              <Typography className="ap-typography ap-typography--sm">
                                {item.name}
                              </Typography>
                            </Grid>
                            <Grid item xs={6} style={{display: 'inline-flex'}}>
                              <Typography className="ap-typography ap-typography--sm">
                                {item.type === 'SignatureField' ? (
                                  <img
                                    src={item.value}
                                    alt={'sign'}
                                    className="new-reservation-signature"
                                  ></img>
                                ) : item.value_name ? (
                                  item.value_name
                                ) : (
                                  item.value
                                )}
                              </Typography>
                            </Grid>
                          </Grid>
                        </ListItem>
                      )
                    })}
                </List>
              ) : (
                <List className="c-reserved-item-list">
                  {reservation.additional_fields.map((item, i) => {
                    return (
                      <ListItem style={{padding: '0px 0px 4px 0px'}}>
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography className="ap-typography ap-typography--sm">
                              {item.name}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography className="ap-typography ap-typography--sm">
                              {item.type === 'SignatureField' ? (
                                <img
                                  src={item.value}
                                  alt={'sign'}
                                  className="new-reservation-signature"
                                ></img>
                              ) : item.value_name ? (
                                item.value_name
                              ) : (
                                item.value
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                      </ListItem>
                    )
                  })}
                </List>
              )}
            </Grid>
          ) : null}
          <Grid item xs={12} className="" style={{marginBottom: '24px'}}>
            <TextField
              id="outlined-basic"
              label=""
              inputStyle={{textAlign: 'center'}}
              placeholder="Add comments"
              variant="outlined"
              className="c-comments-textfield"
              onChange={e => {
                update('comments', e.target.value)
              }}
              multiline
              value={reservation.comments}
              rowsMax={3}
            />
            <Typography className="ap-typography ap-typography--xxs" style={{marginTop: '6px'}}>
              Optional
            </Typography>
          </Grid>
          <Grid item xs={12} className="">
            <Typography
              className="ap-typography ap-typography--xxs"
              style={{paddingTop: '8px', marginRight: '8px'}}
            >
              Notification:
            </Typography>
            {reservation?.reservation_notification?.map((notif, index) => {
              return (
                <Grid key={index} container style={{marginTop: '5px'}}>
                  <Grid item></Grid>
                  <Grid item>
                    <NotificationInput
                      value={{time: notif.time, unit: notif.unit}}
                      onChange={(event, value) => {
                        handleChangeHoldTime(event, value, index)
                      }}
                    />
                  </Grid>
                  <Grid>
                    <CloseIcon className="c-close-icon" onClick={() => removeNotification(index)} />
                  </Grid>
                </Grid>
              )
            })}

            {reservation?.reservation_notification?.length < 3 && (
              <>
                <Typography
                  className="ap-typography ap-typography--xxs"
                  style={{marginTop: '11px', cursor: 'pointer'}}
                  onClick={() => {
                    addNotification()
                  }}
                >
                  Add notification
                </Typography>
              </>
            )}
            <div ref={notifRef}></div>
          </Grid>
        </Grid>
        <div style={{display: 'flex', flexDirection: 'row', padding: '16px 17px 16px 0px'}}>
          {confirmLoading && <LoadingIndicator />}
          {!confirmLoading && (
            <div className="ap-flex ap-flex--end">
              <Button
                className="ap-button ap-button--primary"
                onClick={() => {
                  handleReserveCreate()
                }}
              >
                Confirm
              </Button>
              {!isMainApp && (
                <Button className="ap-button" onClick={handleClickCancel}>
                  Cancel
                </Button>
              )}
            </div>
          )}
        </div>
      </section>
    </>
  )
}
